import { useEffect, useState } from "react";
import { Dropdown, Form, Row, Col, Container } from "react-bootstrap";
import DatePicker from "react-datepicker";
import Page from "./Page";
import LineChart from "./trends/LineChart";
import { Urls } from "../utils/endPoints/apiUrls";
import { apiRequest } from "../utils/comman/apiRequest";
import Loader from "./comman/Loader";
import { fDate } from "../utils/fileHelper";

//-------------------------------------------------------------------------------------------------------------

export default function Trends() {
  const getStartOfCurrentWeek = () => {
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const dayOfWeek = today.getDay(); // Sunday = 0
  today.setDate(today.getDate() - dayOfWeek+1); // back to Sunday
  return fDate(today);
};
  const [filters, setFilters] = useState({
    // date: fDate(new Date()),
    dateRangeType: "current",
    startDate: getStartOfCurrentWeek(),
    selectedMaterials: [""],
    selectedTypes: [""],
    selectedSizes: [""],
    marketplace: "Amazon",
    
  });

  const [materialDropDown, setMaterialDropDown] = useState([]);
  const [typeDropDown, setTypeDropDown] = useState([]);
  const [productSize, setProductSize] = useState([]);

  const [productSpeedTrend, setProductSpeedTrend] = useState([]);
  const [productPriceTrend, setProductPriceTrend] = useState([]);

  const [isLoadingPrice, setIsLoadingPrice] = useState(false);
  const [isLoadingSpeed, setIsLoadingSpeed] = useState(false);

  // const toggleSelection = (value, key) => {
  //   setFilters((prev) => ({
  //     ...prev,
  //     [key]: [value],
  //   }));
  // };

  const toggleSelection = (value, key) => {
    setFilters((prev) => {
      const isAlreadySelected = prev[key]?.includes(value);

      return {
        ...prev,
        [key]: isAlreadySelected ? [] : [value],
      };
    });
  };
  const [dropdowns, setDropdowns] = useState({
    material: false,
    type: false,
    size: false,
    marketplace: false,
  });

  const handleDropdownToggle = (key, isOpen) => {
    setDropdowns((prev) => ({ ...prev, [key]: isOpen }));
  };

  const closeDropdown = (key) => {
    setDropdowns((prev) => ({ ...prev, [key]: false }));
  };

  // Material Dropdown -------------------------

  const fetchMaterialDropdown = async () => {
    const { data, status } = await apiRequest({
      method: "GET",
      endUrl: Urls?.materialDropDown,
    });
    if (status) {
      setMaterialDropDown(data?.rows);
    }
  };

  const updateStartDateByRange = (rangeType) => {
    const today = new Date();
    today.setHours(0, 0, 0, 0);

    if (rangeType === "current") {
      // Start of current week (Sunday)
      const start = new Date(today);
      const dayOfWeek = start.getDay(); // 0 = Sunday, 1 = Monday, ..., 6 = Saturday
      start.setDate(start.getDate() - dayOfWeek +1); // Move to the most recent Sunday

      setFilters((prev) => ({
        ...prev,
        dateRangeType: "current",
        startDate: fDate(start),
      }));
    } else if (rangeType === "lastweek") {
      // Start of last week (Sunday before the current one)
      const start = new Date(today);
      const dayOfWeek = start.getDay(); // 0 = Sunday, 1 = Monday, ..., 6 = Saturday
      start.setDate(start.getDate() - dayOfWeek - 6); // Go back one more week

      setFilters((prev) => ({
        ...prev,
        dateRangeType: "lastweek",
        startDate: fDate(start),
      }));
    }
  };

  // Types Dropdown --------------------------

  const fetchTypesDropdown = async () => {
    const { data, status } = await apiRequest({
      method: "GET",
      endUrl: Urls?.productTypes,
    });
    if (status) {
      setTypeDropDown(data?.rows);
    }
  };

  // Size Dropdown --------------------------

  const fetchSizesDropdown = async () => {
    const { data, status } = await apiRequest({
      method: "GET",
      endUrl: Urls?.productSize,
    });
    if (status) {
      setProductSize(data?.rows);
    }
  };
  // Fetch Price Trends -------------------------

  const fetchPriceTrend = async (customFilters = filters) => {
    setIsLoadingPrice(true);
    const query = {
      startDate: customFilters?.startDate,
      material: customFilters?.selectedMaterials?.[0] || "",
      type: customFilters?.selectedTypes?.[0] || "",
      size: customFilters?.selectedSizes?.[0] || "",
      marketplace: customFilters.marketplace || "",
    };
    console.log("startdate",customFilters?.startDate)
    const { data, status } = await apiRequest({
      method: "GET",
      endUrl: Urls?.priceTrend,
      query: query,
    });
    if (status) {
      setIsLoadingPrice(false);
      setProductPriceTrend(data);
    }
  };

  // Fetch Speed Trends -------------------------
  const fetchSpeedTrend = async (customFilters = filters) => {
    setIsLoadingSpeed(true);
    const query = {
      startDate: customFilters?.startDate,
      material: customFilters?.selectedMaterials?.[0] || "",
      type: customFilters?.selectedTypes?.[0] || "",
      size: customFilters?.selectedSizes?.[0] || "",
      marketplace: customFilters.marketplace || "",
    };
    const { data, status } = await apiRequest({
      method: "GET",
      endUrl: Urls?.speedTrend,
      query: query,
    });
    if (status) {
      setIsLoadingSpeed(false);
      setProductSpeedTrend(data);
    }
  };

  useEffect(() => {
    fetchMaterialDropdown();
    fetchTypesDropdown();
    fetchSizesDropdown();
    
  }, []);

  useEffect(() => {
    fetchSpeedTrend();
    fetchPriceTrend();
  }, [filters]);

  const handleDateRangeChange = (e) => {
    const val = e.target.value;
    if (val === "custom") {
      setFilters((prev) => ({
        ...prev,
        dateRangeType: "custom",
        // Keep existing startDate or clear it for user to pick
      }));
    } else {
      updateStartDateByRange(val);
    }
  };

  return (
    <Page title={"Trends"} subtitle={"Dashboard > Trends"}>
      <Container>
        <Col md={12}>
          <Row className="align-items-center g-0 filterrow">
            {/* Date Range Dropdown */}
            <Col
              xs={12}
              md={filters.dateRangeType === "custom" ? 3 : 5}
              className="px-1"
            >
              <Form.Group as={Row} className="align-items-center">
                <Form.Label column sm={5} className="mb-0 filterText">
                  Date Range:
                </Form.Label>
                <Col sm={7}>
                  <Form.Select
                    value={filters.dateRangeType}
                    onChange={handleDateRangeChange}
                    className="form-control"
                  >
                    <option value="current">Current Week</option>
                    <option value="lastweek">Last Week</option>
                    <option value="custom">Custom</option>
                  </Form.Select>
                </Col>
              </Form.Group>
            </Col>

            {/* Show DatePicker only if custom */}
            {filters.dateRangeType === "custom" && (
              <Col xs={12} md={3}>
                <Form.Label className="mb-0 filterText me-1 ms-2">
                  Select Start Date:
                </Form.Label>
                <DatePicker
                  selected={new Date(filters.startDate)}
                  onChange={(date) =>
                    setFilters((prev) => ({
                      ...prev,
                      startDate: fDate(date),
                    }))
                  }
                  dateFormat="dd MMMM yyyy"
                  className="form-control date-formcontrol"
                  maxDate={new Date()}
                />
              </Col>
            )}

            <Col >
              <Dropdown
                show={dropdowns.material}
                onToggle={(isOpen) => handleDropdownToggle("material", isOpen)}
              >
                <Dropdown.Toggle
                  variant="outline-secondary dropbtn"
                  style={{ borderRight: 0 }}
                >
                  Material:{" "}
                  <span className="droptxt">
                    {filters.selectedMaterials[0] || "Select"}
                  </span>
                </Dropdown.Toggle>

                <Dropdown.Menu>
                  <Form.Label className="px-3 filterText">
                    Select Material
                  </Form.Label>
                  {materialDropDown?.map((mat) => (
                    <Form.Check
                      key={mat?.name}
                      type="checkbox"
                      label={mat?.name}
                      checked={filters.selectedMaterials.includes(mat.name)}
                      // onChange={() => toggleSelection(mat?.name, "selectedMaterials")}
                      onChange={() => {
                        toggleSelection(mat?.name, "selectedMaterials");
                        closeDropdown("material");
                      }}
                    />
                  ))}
                </Dropdown.Menu>
              </Dropdown>
            </Col>

            <Col >
              <Dropdown
                show={dropdowns.type}
                onToggle={(isOpen) => handleDropdownToggle("type", isOpen)}
              >
                <Dropdown.Toggle
                  variant="outline-secondary dropbtn"
                  style={{ borderRight: 0 }}
                >
                  Type:
                  <span className="droptxt">
                    {filters.selectedTypes[0] || "Select"}
                  </span>
                </Dropdown.Toggle>
                <Dropdown.Menu>
                  <Form.Label className="px-3 filterText">
                    Select Type
                  </Form.Label>
                  {typeDropDown?.map((type) => (
                    <Form.Check
                      key={type?.name}
                      type="checkbox"
                      label={type?.name}
                      checked={filters.selectedTypes.includes(type?.name)}
                      // onChange={() => toggleSelection(type?.name, 'selectedTypes')}
                      onChange={() => {
                        toggleSelection(type?.name, "selectedTypes");
                        closeDropdown("type");
                      }}
                    />
                  ))}
                </Dropdown.Menu>
              </Dropdown>
            </Col>
            <Col >
              <Dropdown
                show={dropdowns.size}
                onToggle={(isOpen) => handleDropdownToggle("size", isOpen)}
              >
                <Dropdown.Toggle
                  variant="outline-secondary dropbtn"
                  style={{
                    borderRight: 0,
                    borderTopRightRadius: 8,
                    borderBottomRightRadius: 8,
                  }}
                >
                  Size:
                  <span className="droptxt">
                    {filters.selectedSizes[0] || "Select"}
                  </span>
                </Dropdown.Toggle>
                <Dropdown.Menu>
                  <Form.Label className="px-3 filterText">
                    Select Size
                  </Form.Label>
                  {productSize?.map((size) => (
                    <Form.Check
                      key={size?._id}
                      type="checkbox"
                      label={size?.name}
                      checked={filters.selectedSizes.includes(size?.name)}
                      // onChange={() => toggleSelection(size?.name, 'selectedSizes')}
                      onChange={() => {
                        toggleSelection(size?.name, "selectedSizes");
                        closeDropdown("size");
                      }}
                    />
                  ))}
                </Dropdown.Menu>
              </Dropdown>
            </Col>

            <Col>
              <Dropdown
                show={dropdowns.marketplace}
                onToggle={(isOpen) =>
                  handleDropdownToggle("marketplace", isOpen)
                }
              >
                <Dropdown.Toggle
                  variant="outline-secondary dropbtn"
                  style={{
                    borderRight: 0,
                    borderTopRightRadius: 8,
                    borderBottomRightRadius: 8,
                  }}
                >
                  Marketplace:{" "}
                  <span className="droptxt">
                    {filters.marketplace || "Select"}
                  </span>
                </Dropdown.Toggle>
                <Dropdown.Menu>
                  <Form.Label className="px-3 filterText">
                    Select Marketplace
                  </Form.Label>
                  {["Amazon", "Flipkart"].map((market) => (
                    <Form.Check
                      key={market}
                      type="checkbox"
                      label={market}
                      checked={filters.marketplace === market}
                      onChange={() => {
                        setFilters((prev) => {
                          const isSame = prev.marketplace === market;
                          return {
                            ...prev,
                            marketplace: isSame ? "Amazon" : market, // fallback to Amazon if same clicked
                          };
                        });
                        closeDropdown("marketplace");
                      }}
                    />
                  ))}
                </Dropdown.Menu>
              </Dropdown>
            </Col>
          </Row>
        </Col>
        {/* ---------------------------------- */}
        <Row>
          {/* Speed Chart */}
          <Col xs={12} md={12} className="mt-5">
            <p className="speed-chart-heading">Speed Comparision</p>
            {isLoadingSpeed ? (
              <Loader />
            ) : productSpeedTrend.length ? (
              <LineChart
                materialData={productSpeedTrend}
                yaxis={"Speed (days)"}
              />
            ) : (
              <p className="text-center f-16 mt-2">Data not found</p>
            )}
          </Col>

          {/* Price Chart */}
          <Col xs={12} md={12} className="mt-5">
            <p className="speed-chart-heading">Price Comparision</p>
            {isLoadingPrice ? (
              <Loader />
            ) : productPriceTrend.length ? (
              <LineChart
                materialData={productPriceTrend}
                yaxis={"Price (Rupees)"}
              />
            ) : (
              <p className="text-center f-16 mt-2">Data not found</p>
            )}
          </Col>
        </Row>
      </Container>
    </Page>
  );
}
